module.exports = __webpack_public_path__ + "static/img/honor.9cde38f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homePage/honor.png
// module id = TXG4
// module chunks = 0